import { BrowserRouter, Routes, Route } from "react-router-dom";
import { QueryProvider } from "./providers/QueryProvider";
import { ThemeProvider } from "./providers/ThemeProvider";
import { HarnessProvider } from "@/harness/HarnessContext";

import { LandingPage } from "@/pages/landing/LandingPage";
import { DashboardPage } from "@/pages/dashboard/DashboardPage";
import { SubjectsPage } from "@/pages/subjects/SubjectsPage";
import { LessonsPage } from "@/pages/lessons/LessonsPage";
import { ClassroomPage } from "@/pages/classroom/ClassroomPage";
import { HomeworkPage } from "@/pages/homework/HomeworkPage";
import { BookmarksPage } from "@/pages/bookmarks/BookmarksPage";
import { HistoryPage } from "@/pages/history/HistoryPage";
import { ProgressPage } from "@/pages/progress/ProgressPage";
import { SettingsPage } from "@/pages/settings/SettingsPage";
import { AboutPage } from "@/pages/about/AboutPage";
import { NotFoundPage } from "@/pages/not-found/NotFoundPage";

export default function App() {
  return (
    <ThemeProvider>
      <QueryProvider>
        <HarnessProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/subjects" element={<SubjectsPage />} />
              <Route path="/lessons" element={<LessonsPage />} />
              <Route path="/classroom" element={<ClassroomPage />} />
              <Route path="/homework" element={<HomeworkPage />} />
              <Route path="/bookmarks" element={<BookmarksPage />} />
              <Route path="/history" element={<HistoryPage />} />
              <Route path="/progress" element={<ProgressPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </BrowserRouter>
        </HarnessProvider>
      </QueryProvider>
    </ThemeProvider>
  );
}
